import { ValueOf } from "@/lib/utils";

// VoC期間フィルターのタイプ
export const VocPeriodFilterType = {
  ALL: "all",
  CUSTOM: "custom",
} as const;

export type VocPeriodFilterType = ValueOf<typeof VocPeriodFilterType>;

// VoC期間フィルター
export type VocPeriodFilter = {
  type: VocPeriodFilterType;
  start: Date | null;
  end: Date | null;
};
